module.exports = __webpack_public_path__ + "static/img/partner-timesdf.e72e628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-timesdf.png
// module id = VKtK
// module chunks = 34